import React from 'react';

import {
	Flex,
	Heading,
	VStack,
	Text,
	chakra,
	Image
} from '@chakra-ui/react';
import Echo from '../../../Assets/svg/Echo.svg';


export const EchoJumbotron = () => {
	return (
		<Flex
			alignItems={['center', 'center']}
			flexDirection={{ base: 'column', md: 'row' }}
			justifyContent={['center']}
			h={['100vh',null, null, null, '100vh','100vh']}
			mt={{base:'-12', xl:''}}
		>
			<VStack
				alignItems={['flex-start', 'center']}
				spacing={10}
				textAlign={['left', 'left', 'center']}
			>
				<VStack alignItems={['flex-start', 'flex-start', 'center']} spacing={[8,8]} >
					
					<Image src={Echo} boxSize={['70px','80px']} />
					<Heading textTransform={'uppercase'} fontSize={{ base: '40px', tablet: '2xl', xxl: '5xl' }}
						color="black" 
						w={['100%', '100%',null, null, '80%']}
						fontWeight={'bold'}
						letterSpacing={[0,'-0.03em']}
					>
						INTRODUCING <chakra.span color={'#00A0E9'}>ECHO AI</chakra.span> 
					</Heading>
					<Text fontSize={{ base: '16px', tablet: '16px', xxl:'16px' }} 
						color="black" 
						w={['100%', '100%',null, null, '80%']}
						fontWeight={'medium'}
						letterSpacing={'-0.03em'}
					>
						Our proprietary  AI Interviewer enabling timed, contextually aware text or voice conversations with customers at-scale
					</Text>
					<Text fontSize={{ base: '16px', tablet: '16px', xxl:'16px' }} 
						lineHeight={6} w={{base:'100%',xl:'50%'}} 
						color="black"
						fontWeight={'bold'}
					>
                        Coming Soon...
					</Text>
				</VStack>
                
			</VStack>
		</Flex>
	);
};
